module.exports = __webpack_public_path__ + "static/media/link.48a19404.svg";